import { Box, Flex, Spinner } from '@chakra-ui/react'
import React from 'react'

interface MessageProps {
  message: string
  addSpinner?: boolean
}

function Message({ message, addSpinner = false }: MessageProps) {
  return (
    <Flex
      align="center"
      justify="center"
      height="80vh" // Set the desired height
    >
      <Box textAlign="center">
        {addSpinner ? (
          <Spinner
            thickness="4px"
            speed="0.65s"
            emptyColor="gray.200"
            color="orange.500"
            size="xl"
          />
        ) : null}
        <p>{message}</p>
      </Box>
    </Flex>
  )
}

export default Message
